type ExceptionValue = {
  type?: string;
  value?: string;
};

const NETWORK_ERROR_MESSAGES = new Set([
  "Network request failed",
  "Failed to fetch",
  "NetworkError",
  "timeout exceeded",
  "withrealtime/messaging",
  "Request failed with status code 401",
  "Request failed with status code 403",
  "Request failed with status code 404",
  "Request aborted",
  "Network Error",
  "Internal Server Error",
  "Content Security Policy",
  "ContentSecurityPolicyError",
  "ContentSecurityPolicy",
  "503 Service Unavailable",
  "Unexpected token '='",
  "opts is not defined",
]);

export const shouldIgnoreByMessage = (message?: string): boolean => {
  if (!message) return false;
  return NETWORK_ERROR_MESSAGES.has(message);
};

export const shouldIgnoreException = (
  exception?: ExceptionValue,
  requestUrl?: string,
): boolean => {
  if (!exception) return false;

  const { type, value = "" } = exception;

  // Ignore CSP report endpoint
  if (requestUrl?.includes("/csp-report")) return true;

  // Specific type + message rules
  if (type === "ReferenceError" && value.includes("gmo")) return true;

  if (
    type === "UnhandledRejection" &&
    value === "Non-Error promise rejection captured with value: undefined"
  )
    return true;

  // Message pattern rules
  if (value.includes("_leaflet_pos")) return true;

  if (value.includes("Cannot redefine property: create")) return true;

  return false;
};
